import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LoadingSpinnerService } from '../../../../shared/services/loading-spinner.service';
import { JobsService } from '../jobs.service';
import { DataCheckService } from '../../../../shared/services/data-check.service';

@Component({
  selector: 'gtapp-add-job',
  templateUrl: './add-job.component.html',
  styleUrl: './add-job.component.scss',
  standalone: false,
})
export class AddJobComponent implements OnInit {
  selectedJobType: any = {};

  jobType: string = '';

  constructor(
    private jobService: JobsService,
    private spinnerService: LoadingSpinnerService,
    private route: ActivatedRoute,
    private dataCheckService: DataCheckService,
  ) {
    if (this.route.snapshot.fragment) {
      this.jobType = this.route.snapshot.fragment;
    }
  }

  jobTypes: any = [];

  ngOnInit(): void {
    this.getAllPossibleJobTypes();
  }
  // job type identities
  // IDENTITY_RESPONSE = 0, _("RESPONSE")
  // IDENTITY_SERVICE = 1, _("SERVICE")
  // IDENTITY_STATIC_GUARD = 2, _("STATIC GUARD")
  // IDENTITY_OTHERS = 3, _("OTHER")
  // IDENTITY_CHECKPOINT_PATROL = 4, _("CHECKPOINT PATROL")
  // IDENTITY_CASUAL_PATROL = 5, _("CASUAL PATROL")
  // IDENTITY_RUNSHEET = 6, _("RUNSHEET")

  //Method to Get Status, Priority,Service Type details for adding job
  getAllPossibleJobTypes() {
    this.spinnerService.show();
    let subscriberStats = JSON.parse(
      localStorage.getItem('subscriberStats') || '{}',
    );
    const isAdmin = this.dataCheckService.isUserAdmin();

    this.jobService.getJobParams().subscribe((response: any) => {
      if (response['status'] == 'success') {
        if (this.jobType === 'roster') {
          const filteredJobTypes = response?.data?.filter(
            (_type: any) =>
              ![0, 5, 6].includes(_type?.type_identity) &&
              (_type?.type_identity === 4
                ? subscriberStats.checkpoint_count > 0 &&
                  (isAdmin ||
                    this.dataCheckService.isDispatchUser({
                      permission: 'job_type',
                      action: 'add',
                      id: _type?.id,
                    }))
                : isAdmin ||
                  this.dataCheckService.isDispatchUser({
                    permission: 'job_type',
                    action: 'add',
                    id: _type?.id,
                  })),
          );

          const rosterCopyJobInfo = JSON.parse(
            sessionStorage.getItem(btoa('rosterCopyJobInfo')) || '{}',
          );
          const schedulePrefilledData = JSON.parse(
            sessionStorage.getItem(btoa('schedulePrefilledData')) || '{}',
          );
          let selectedJobType: any;
          if (rosterCopyJobInfo?.id) {
            selectedJobType = filteredJobTypes?.find((jTYpe: any) =>
              rosterCopyJobInfo?.job_type_dict?.id
                ? rosterCopyJobInfo?.job_type_dict?.id == jTYpe?.id
                : rosterCopyJobInfo?.job_type_dict?.type_identity ==
                    jTYpe?.type_identity && jTYpe?.type_identity === 4,
            );

            if (selectedJobType?.id) {
              this.changeJobType(selectedJobType);
            } else {
              this.jobTypes = filteredJobTypes;
            }
          } else if (schedulePrefilledData?.shift?.name) {
            selectedJobType = filteredJobTypes?.find(
              (jTYpe: any) => jTYpe?.type_identity === 4,
            );
            if (selectedJobType?.id) {
              this.changeJobType(selectedJobType);
            } else {
              this.jobTypes = filteredJobTypes;
            }
          } else {
            this.jobTypes = filteredJobTypes;
          }
          if (this.jobTypes?.length === 1) {
            this.changeJobType(this.jobTypes[0]);
          }
        } else if (this.jobType === 'adHoc') {
          let responseType = response['data']?.find(
            (status: any) => status?.type_identity === 5,
          );
          this.changeJobType(responseType);
        } else {
          let responseType = response['data']?.find(
            (status: any) => status?.type_identity === 0,
          );
          this.changeJobType(responseType);
        }

        this.spinnerService.hide();
      } else {
        this.spinnerService.hide();
      }
    });
  }

  changeJobType(service: any) {
    this.selectedJobType = service;
  }
}
